import { createSlice } from "@reduxjs/toolkit";
export const initialState =null

// this is for single Voucher search
const VoucherDetail = createSlice({
    name: "voucherDetailSlice",
    initialState: initialState,
    reducers: {

        addVoucherData: (state, action) => {
           
            return action.payload;
          
          },
    }
})







export const { addVoucherData } =  VoucherDetail.actions;

export default   VoucherDetail.reducer;
